import Arrow from './Arrow.js';
import ArrowDiagonal from './ArrowDiagonal.js';
import Caret from './Caret.js';
import Chevron from './Chevron.js';
export const AlignedIcons = {
    Arrow,
    ArrowDiagonal,
    Caret,
    Chevron,
};
export default AlignedIcons;
